import { render, staticRenderFns } from "./star.vue?vue&type=template&id=432a3a3f&"
import script from "./star.vue?vue&type=script&lang=js&"
export * from "./star.vue?vue&type=script&lang=js&"
import style0 from "./star.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports